import { URL } from '@core/constants/url.constant';
import { ApiValidate } from '@core/decorators/ApiValidate.decorator';
import { apiService } from '@core/services/Api.service';
import { generateStringWithQueryParams } from '@shared/utils/generateStringWithQueryParams.util';
import {
  sessionsListSchema,
  createSessionSchema,
  chatHistorySchema
} from '../schemas/flowChat.schema';
import type {
  TGetSessionsRequest,
  TCreateSessionRequest,
  TGetSessionsResponse,
  TCreateSessionResponse,
  TGetChatHistoryRequest,
  TGetChatHistoryResponse,
  TAbortAnswerGenerationRequest
} from '../models/flowChat.model';

class AbcloudzFlowChatService {
  @ApiValidate(sessionsListSchema)
  public getSessions({ flowId, limit, offset, order, silent }: TGetSessionsRequest) {
    return apiService.get<TGetSessionsResponse>({
      url: `${URL.flow}/${flowId}/chat/sessions${generateStringWithQueryParams({ limit, offset, order })}`,
      config: { silent }
    });
  }

  @ApiValidate(createSessionSchema)
  public createSession({ flowId, dto, silent }: TCreateSessionRequest) {
    return apiService.post<TCreateSessionResponse>({
      url: `${URL.flow}/${flowId}/chat/sessions`,
      dto,
      config: { silent }
    });
  }

  @ApiValidate(chatHistorySchema)
  public getChatHistory({
    flowId,
    sessionId,
    limit,
    offset,
    order,
    silent
  }: TGetChatHistoryRequest) {
    return apiService.get<TGetChatHistoryResponse>({
      url: `${URL.flow}/${flowId}/chat/sessions/${sessionId}/messages${generateStringWithQueryParams({ limit, offset, order })}`,
      config: { silent }
    });
  }

  public abortAnswerGeneration({ flowId, sessionId, silent }: TAbortAnswerGenerationRequest) {
    return apiService.delete({
      url: `${URL.flow}/${flowId}/chat/sessions/${sessionId}/abort`,
      config: { silent }
    });
  }
}

const abcloudzFlowChatService = new AbcloudzFlowChatService();

export { abcloudzFlowChatService };
